import React, { useMemo, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

const TERMS_PAGE_URL = 'https://www.pecuaria.io/termos-privacidade';

const consentItems = ['privacy', 'terms', 'beta'];

const TermsAndDisclaimer = ({ onAcceptAll }) => {
  const { t } = useTranslation('legal');
  const [acceptedItems, setAcceptedItems] = useState({});
  const allAccepted = useMemo(
    () => consentItems.every((id) => acceptedItems[id]),
    [acceptedItems]
  );

  const toggleItem = (id) => {
    setAcceptedItems((currentItems) => ({
      ...currentItems,
      [id]: !currentItems[id]
    }));
  };

  return (
    <section
      className="mt-3 w-full max-w-xl rounded-lg border border-primary-200 bg-white p-3 shadow-md sm:mt-6 md:p-5"
      aria-labelledby="terms-consent-title"
    >
      <header className="border-b border-primary-100 pb-2 sm:pb-3">
        <h2 id="terms-consent-title" className="text-sm font-semibold text-primary-700 sm:text-lg">
          {t('title')}
        </h2>
        <p className="mt-1 text-xs text-gray-700 sm:text-sm">
          {t('description')}
        </p>
        <p className="mt-2 text-xs text-gray-700">{t('officialLanguage')}</p>
      </header>

      <ul className="mt-3 space-y-2 sm:mt-4 sm:space-y-3" aria-label={t('itemsLabel')}>
        {consentItems.map((id) => (
          <li key={id} className="rounded-lg border border-gray-200 bg-gray-50 p-2.5 sm:p-3">
            <div className="flex items-start gap-2.5 sm:gap-3">
              <input
                id={`terms-${id}`}
                type="checkbox"
                checked={Boolean(acceptedItems[id])}
                onChange={() => toggleItem(id)}
                className="mt-1 h-5 w-5 shrink-0 accent-action"
              />
              <div className="min-w-0 flex-1">
                <label htmlFor={`terms-${id}`} className="cursor-pointer text-xs font-semibold text-gray-900 sm:text-sm">
                  <Trans
                    t={t}
                    i18nKey="agreement"
                    values={{ title: t(`documents.${id}.title`) }}
                    components={{
                      document: (
                        <a
                          href={TERMS_PAGE_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-medium text-primary-700 underline underline-offset-2 hover:text-primary-800 focus:outline-none focus:ring-2 focus:ring-focus focus:ring-offset-2"
                          aria-label={t('readDocument', { title: t(`documents.${id}.title`) })}
                        />
                      ),
                    }}
                  />
                </label>
                <p className="mt-0.5 text-xs text-gray-700">
                  {t(`documents.${id}.description`)}
                </p>
              </div>
            </div>
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={() => onAcceptAll(acceptedItems)}
        disabled={!allAccepted}
        className="motion-interactive mt-4 min-h-[44px] w-full rounded bg-action px-4 py-2 text-sm font-semibold text-white hover:bg-action-hover focus:outline-none focus:ring-2 focus:ring-focus focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-action sm:mt-5"
      >
        {t('confirm')}
      </button>
    </section>
  );
};

export default TermsAndDisclaimer;
